<template>
  <t-drawer
    :visible="drawerVisible"
    :closeBtn="false"
    :footer="false"
    size="850"
    class="xw-drawer"
    @close="handleClose"
  >
    <template #header>
      <div>
        <div>
          <span>{{title}}</span>
          <span @click="handleClose" >
            <icon-font name="icon-close" />
          </span>
        </div>
        <div>操作记录</div>
      </div>
    </template>
    <template #body>
      <slot name="body"></slot>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </t-drawer>
</template>
<script>
export default {
  name: 'xw-modal',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title:{
      type: String,
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    }
  }
}
</script>
<style lang="less" scoped>
.xw-drawer {
  /deep/.t-drawer__header {
    border-bottom: 0;
    height: 50px;
    background: #f5f6f7;
    min-height: 51px;
    padding: 0;
    > div {
      width: 100%;
      display: flex;
      >div:nth-child(1) {
        width: 440px;
        font-size: 14px;
        color: #2e343d;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 0 12px;
        border-bottom: 1px solid #e0e2e5;
        .icon-font {
          cursor: pointer;
        }
      }
      >div:nth-child(2) {
        flex: 1;
        font-size: 14px;
        color: #2e343d;
        line-height: 50px;
        margin-left: 10px;
        background: #fff;
        padding: 0 12px;
        border-bottom: 1px solid #e0e2e5;
      }
    }
  }
  /deep/.t-drawer__body {
    background: #f5f6f7;
    padding: 0;
    > div:nth-child(1) {
      width: 100%;
      display: flex;
      height: 100%;
      justify-content: space-between;
      >div:nth-child(1) {
        width: 440px;
        height: calc(100% - 50px);
        background: #fff;
        padding: 20px 10px;
        overflow: hidden;
        overflow-y: auto;
      }
      >div:nth-child(2) {
        flex: 1;
        height: 100%;
        margin-left: 10px;
        background: #fff;
        padding: 20px;
        overflow: hidden;
        overflow-y: auto;
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      width: 440px;
      height: 50px;
      display: flex;
      align-items: center;
      gap: 6px;
      border-top: 1px solid #e0e2e5;
      padding: 0 12px;
      background: #fff;
    }
  }
}
</style>
